module.exports = __webpack_public_path__ + "media/images/etyekilogo-etyeki-64x64-6d37f90f78e5c1ee6d337096c90665fa.png";